module.exports = __webpack_public_path__ + "static/media/Journey 02.de93f6e6.png";